// extracted by mini-css-extract-plugin
export default {"menuBlock":"tE-z","title":"uE-z","nav":"vE-z","flexCell":"wE-z","facetLink":"xE-z"};